import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Text,
    Box,
    Image,
    Button,
    Switch,
    Flex,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter
} from "@chakra-ui/react";

import { getApi } from "common/services/api";
import CommonCheckTable from "common/components/checktable";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { deleteManyApi } from "common/services/api";
import { toast } from "react-toastify";
import { crmConstant } from "services/Crm/constant";
import editIcon from "common/assets/img/editIcon.png";
import deleteIcon from "common/assets/img/deleteIcon.png";
import { constant } from "common/constant";
import { IoIosArrowBack } from "react-icons/io";
import DynamicFormModal from "common/components/dynamicFormModal";
import { createRuleFields } from "common/constant";
import { patchApi } from "common/services/api";

const WorkflowRules = () => {
    const title = "Workflow Rules";
    const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
    const [deleteMany, setDelete] = useState(false);
    const [selectedValues, setSelectedValues] = useState([]);
    const [menuSelectedDeleteItem, setMenuSelectedDeleteItem] = useState([]);
    const user = JSON.parse(localStorage.getItem("user"));
    const [edit, setEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const [pendingToggle, setPendingToggle] = useState(null);
    const [selectedId, setSelectedId] = useState();
    const [searchbox, setSearchbox] = useState(null);
    const [currentPage, setCurrentPage] = useState(() => {
        const paginationState = JSON.parse(localStorage.getItem("paginationState"));
        return paginationState?.pageName === title && paginationState?.currentPage
            ? paginationState.currentPage
            : 1;
    });

    const [pageSize, setPageSize] = useState(() => {
        const paginationState = JSON.parse(localStorage.getItem("paginationState"));
        return paginationState?.pageName === title && paginationState?.pageSize
            ? paginationState.pageSize
            : 10;
    });
    const [isOpen, setIsOpen] = useState(false);
    const [sortColumn, setSortColumn] = useState(null)
    const [sortOrder, setSortOrder] = useState('')

    const handleConfirmToggle = async () => {
        if (pendingToggle) {
            await handleStatusToggle(pendingToggle.id, pendingToggle.newStatus);
            // Optionally update local state in StatusToggleCell
            setPendingToggle({ ...pendingToggle, hasToggled: true });
        }
        setIsConfirmOpen(false);
        setPendingToggle(null);
    };
    const handleEdit = (id) => {
        navigate(`/crm/workflow-rules/create`, { state: { id } });
    };
    const StatusToggleCell = ({ value, row, onToggle }) => {
        const [isLoading, setIsLoading] = useState(false);
        const [isActive, setIsActive] = useState(value);

        // const handleToggle = async () => {
        //     setIsLoading(true);
        //     try {
        //         await onToggle(row.original._id, !isActive);
        //         setIsActive(!isActive);
        //     } catch (err) {
        //         console.error("Error updating status:", err);
        //     } finally {
        //         setIsLoading(false);
        //     }
        // };
        const handleToggle = () => {
            setPendingToggle({
                id: row.original._id,
                newStatus: !isActive,
                setIsActive,
            });
            setIsConfirmOpen(true);
        };

        useEffect(() => {
            if (pendingToggle && pendingToggle.id === row.original._id && pendingToggle.hasToggled) {
                setIsActive(pendingToggle.newStatus);
            }
        }, [pendingToggle]);

        return (
            <Flex align="center">
                <Switch
                    isChecked={isActive}
                    isDisabled={isLoading}
                    onChange={handleToggle}
                    colorScheme="blue"
                />
                <Text ml={2} fontWeight="600" color={isActive ? "blue.500" : "red.500"}>
                    {isActive ? "Active" : "Inactive"}
                </Text>
            </Flex>
        );
    };
    const handleStatusToggle = async (id, newStatus) => {
        try {
            let response = await patchApi(
                `api/workflows/${id}/status`,
                { isActive: newStatus },
            );

            if (response.status === 200) {
                fetchData();
            } else {
                toast.error(constant.somethingWrong);
            }
        } catch (e) {
            toast.error(constant.somethingWrong);
        } finally {
            setIsLoading(false);
        }
    };

    const tableColumns = [
        {
            Header: "#",
            accessor: "_id",
            isSortable: false,
            width: 10,
        },
        {
            Header: "Rule Name",
            accessor: "name",
            cell: (cell) => (
                <Text
                    me="10px"
                    onClick={() => {
                        setEdit(true);
                        setSelectedId(cell?.row?.original?._id);
                        setEditData(cell?.row?.original);
                        navigate(`/crm/workflow-rules/create`, { state: { id: cell?.row?.original?._id } });
                    }}
                    color="brand.600"
                    sx={{
                        "&:hover": {
                            color: "blue.500",
                            textDecoration: "underline",
                            cursor: "pointer",
                        },
                    }}
                    fontSize="sm"
                    fontWeight="700"
                >
                    {cell?.value}
                </Text>
            ),
        },
        {
            Header: "All Module",
            accessor: "module",
            cell: ({ value }) => <Text textTransform="capitalize">{value || "-"}</Text>,
        },
        {
            Header: "Execute On",
            accessor: "trigger",
            cell: ({ row }) => {
                const type = row?.original?.trigger?.type;
                return <Text textTransform="capitalize">{type || "-"}</Text>;
            },
        },
        {
            Header: "Modified On",
            accessor: "updatedAt",
            cell: ({ value }) => (
                <Text>{value ? new Date(value).toLocaleString() : "-"}</Text>
            ),
        },
        {
            Header: "Version",
            accessor: "version",
            cell: ({ value }) => <Text>{value || "-"}</Text>,
        },
        {
            Header: "Last Executed",
            accessor: "updatedAts",
            cell: ({ value }) => (
                <Text>{value ? new Date(value).toLocaleString() : "-"}</Text>
            ),
        },
        {
            Header: "Execution Count",
            accessor: "executionCount",
            cell: ({ value }) => <Text>{value ?? 0}</Text>,
        },
        {
            Header: "Status",
            accessor: "isActive",
            cell: ({ value, row }) => (
                <StatusToggleCell value={value} row={row}
                //  onToggle={handleStatusToggle}
                />
            ),
        },
        {
            Header: crmConstant.action,
            accessor: "action",
            isSortable: false,
            center: true,
            cell: ({ row }) => (
                <Box className="actionCellContainer">
                    <Box className="toolTipBox">
                        <Image
                            onClick={() => {
                                handleEdit(row?.original._id);
                            }}
                            src={editIcon}
                            h={"16px"}
                            w={"16px"}
                        />
                        <Text className="toolTip">{constant.edit}</Text>
                    </Box>

                    <Box className="toolTipBox">
                        <Image
                            onClick={() => {
                                setSelectedValues([row?.original._id]);
                                setDelete(true);
                                setMenuSelectedDeleteItem([row?.values?._id]);
                            }}
                            src={deleteIcon}
                            h={"16px"}
                            w={"16px"}
                        />
                        <Text className="toolTip">{constant.delete}</Text>
                    </Box>
                </Box>
            ),
        },
    ];



    const [action, setAction] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);
    const [metadata, setMetadata] = useState({});

    useEffect(() => {
        document.body.classList.add("bgWhiteImp");
        return () => {
            document.body.classList.remove("bgWhiteImp");
        };
    }, []);

    const fetchData = async (currentPage, pageSize, sortKey = sortColumn, order = sortOrder, searchTerm = "") => {
        try {
            let endpoint =
                user?.role === "superAdmin"
                    ? `api/workflows/?page=${currentPage}&limit=${pageSize}`
                    : `api/workflows/?createBy=${user?._id || (() => {
                        console.warn("User ID is undefined, using fallback value.");
                        return "unknown";
                    })()}&page=${currentPage}&limit=${pageSize}`;
            if (sortKey) {
                const sortParam = order === "desc" ? `-${sortKey}` : sortKey;
                endpoint += `&sort=${sortParam}`;
            }
            if (searchTerm) {
                endpoint += `&search=${encodeURIComponent(searchTerm)}`;
            }


            const result = await getApi(endpoint);
            setData(result?.data?.data || []);
            setMetadata(result?.data?.metadata || {});
        } catch (error) {
            console.error("Failed to fetch reporting data:", error);
        } finally {
            setIsLoading(false);
        }

    };


    useEffect(() => {
        fetchData(currentPage, pageSize, sortColumn, sortOrder, searchbox);
    }, [action]);


    const handleSearchChange = (term) => {
        const pageToFetch = term?.trim() === "" ? currentPage : 1;
        fetchData(pageToFetch, pageSize, sortColumn, sortOrder, term);
    };
    const handleSortChange = (accessorKey) => {
        let newSortOrder = 'asc';

        if (sortColumn === accessorKey) {
            newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        }

        setSortColumn(accessorKey);
        setSortOrder(newSortOrder);

        fetchData(currentPage, pageSize, accessorKey, newSortOrder);
    };
    const handleDeleteClick = async () => {
        try {
            setIsLoading(true);
            const payload = {
                ruleIds: selectedValues,
            };

            const response = await deleteManyApi(`api/workflows/bulk-delete`, payload);
            console.log({ response });
            if (response.status === 200) {
                setSelectedValues([]);
                setDelete(false);
                setAction((pre) => !pre);
            } else {
                throw new Error(response);
            }
        } catch (error) {
            toast.error(crmConstant.someThingWentWrong);
        } finally {
            setIsLoading(false);
            setMenuSelectedDeleteItem([]);
        }
    };
    const onOpen = () => {
        setIsOpen(true);
    }
    const onClose = () => {
        setIsOpen(!isOpen);
    }
    const permission = user?.permissions || {
        create: true,
        edit: true,
        delete: true,
        view: true,
    };

    const handleCreateRule = (formData) => {
        console.log("Create Rule Data:", formData);
        localStorage.setItem("workflowRuleData", JSON.stringify(formData));
        navigate("/crm/workflow-rules/create");
    };
    const handleLinkClick = (id) => {
        console.log("Link clicked with ID:", id);
        navigate(`/crm/workflow-rules/create`, { state: { id } });

    }

    return (
        <div className="workflow-rules-table-container">
            <CommonCheckTable
                title={title}
                isLoading={isLoading}
                columnData={tableColumns}
                dataColumn={tableColumns}
                allData={data}
                onLinkClick={handleLinkClick}
                checkBox={true}
                access={permission}
                action={action}
                setAction={setAction}
                setDelete={setDelete}
                BackButton={
                    <Button
                        className="shape-default"
                        onClick={() => navigate("/admin-setting")}
                        variant="brand"
                        size="sm"
                        leftIcon={<IoIosArrowBack />}
                    >
                        Back
                    </Button>
                }
                getTagValuesOutSide={getTagValuesOutSide}
                setGetTagValuesOutside={setGetTagValuesOutside}
                ManageGrid={false}
                onOpen={onOpen}
                tableData={data}
                tableCustomFields={[]}
                deleteMany={false}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                selectedColumns={selectedColumns}
                setSelectedColumns={setSelectedColumns}
                setCurrentPage={setCurrentPage}
                currentPage={currentPage}
                fetchData={fetchData}
                pageSize={pageSize}
                setPageSize={setPageSize}
                metadata={metadata}
                sortOrder={sortOrder}
                handleSortChange={handleSortChange}
                handleSearchChange={handleSearchChange}
                searchbox={searchbox}
                setSearchbox={setSearchbox}
            />

            <DynamicFormModal
                isOpen={isOpen}
                onClose={onClose}
                title="Create Rule"
                fields={createRuleFields}
                onSubmit={handleCreateRule}
            />

            <Modal isOpen={isConfirmOpen} onClose={() => setIsConfirmOpen(false)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{constant.confirmStatus}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {constant.confirmStatusDesc}
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="outline" mr={3} onClick={() => setIsConfirmOpen(false)}>
                            {constant.cancel}
                        </Button>
                        <Button variant={"brand"} onClick={handleConfirmToggle}>
                            {constant.confirm}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <CommonDeleteModel
                isOpen={deleteMany}
                onClose={() => {
                    setDelete(false)
                    setSelectedValues([])
                }}
                type={
                    menuSelectedDeleteItem.length > 0
                        ? crmConstant.workflowRule
                        : selectedValues && selectedValues.length > 1
                            ? `${crmConstant.workflowRule} s`
                            : crmConstant.workflowRule
                }
                handleDeleteData={handleDeleteClick}
                ids={selectedValues}
                selectedValues={selectedValues}
            />
        </div>
    );;
};



export default WorkflowRules;
